import { Component, ElementRef } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { GlobalMessageService, GlobalMessageType, RoutingService } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { filter, map, switchMap } from 'rxjs/operators'
import { EbAddedToCartDialogComponent } from '../../../cart/components/added-to-cart-dialog/eb-added-to-cart-dialog.component'

@Component({
    selector: 'eb-added-favorites-to-cart',
    templateUrl: './eb-added-favorites-to-cart.component.html',
    styleUrls: ['./eb-added-favorites-to-cart.component.scss'],
    standalone: false
})
export class EbAddedFavoritesToCartComponent extends EbAddedToCartDialogComponent {
  addedEntries: number
  entriesTriedToAdd: number
  addedEntriesWereMerged$: Observable<boolean>

  constructor(
    activeCartFacade: ActiveCartFacade,
    launchDialogService: LaunchDialogService,
    routingService: RoutingService,
    el: ElementRef,
    protected globalMessageService: GlobalMessageService
  ) {
    super(activeCartFacade, launchDialogService, routingService, el)
  }

  ngOnInit() {
    if (this.entriesTriedToAdd !== this.addedEntries) {
      this.globalMessageService.add(
        {
          key: 'addFavoritesToCart.entriesWithoutPrice',
          params: { count: this.entriesTriedToAdd - this.addedEntries }
        },
        GlobalMessageType.MSG_TYPE_WARNING,
        Number.MAX_VALUE
      )
    }
    this.addedEntriesWereMerged$ = this.loaded$.pipe(
      filter(loaded => loaded),
      switchMap(() => this.activeCartFacade.getEntries()),
      map(entries => entries.length === this.entriesTriedToAdd)
    )
    super.ngOnInit()
  }
}
